import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-principle-message',
  templateUrl: './principle-message.component.html',
  styleUrls: ['./principle-message.component.scss']
})
export class PrincipleMessageComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
